// ─────────────────────────────────────────────────────────────────────────────
// 🔑 THE STEP LINE AND BAR — ON THE DASHBOARD ONLY since Hannah's production review 2026-11-03 (Jesse/Hannah, 2026-11-02 — the Home Shopping page redesign). Replaces
// the blue 8-step tracker (AppShell's ProgressBar). The guided flow's own pieces: its step context (GuidedShell — "Step X
// of N" 13px, the name 18px/600, the bar 12px below) and GuidedProgress's segments (blue done, yellow current, grey
// upcoming), in the guided column (constants/guidedLayout). On the dashboard, "Welcome back, [first name]" sits above it
// (small, as in the guided flow). The stage → step map is constants/journeySteps (display only).
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';
import GuidedProgress from './guided/GuidedProgress';
import { journeyStepFor, journeyStepNameRow, JOURNEY_COPY, DASHBOARD_GREETING } from '../constants/journeySteps';
import GuidedWelcomeCard from './guided/GuidedWelcomeCard';

export default function JourneyHeader({ status, welcomeName = undefined, greeting = DASHBOARD_GREETING }) {
  const j = journeyStepFor(status);
  if (!j) return null;
  return (
    // 🔑 Inside AppShell's page container (components/BorrowerPageContainer — its width, gutter and top), on the
    // dashboard only (Hannah's review 2026-11-03).
    <div data-testid="journey-header" data-step={j.step} style={{ paddingBottom: 4 }}>
      <div>
        {/* 🔑 The greeting: constants/journeySteps DASHBOARD_GREETING ('current' ships; a–d are Hannah's options). */}
        {welcomeName !== undefined && greeting === 'current' && (
          <div data-testid="journey-welcome" data-greeting="current" style={{ fontSize: 13, color: '#000', marginBottom: 6 }}>{JOURNEY_COPY.welcome(welcomeName)}</div>
        )}
        {/* 🔑 'heading' — APPROVED (Hannah 2026-11-03): small "Step X of 5" (a phone: "Step X of 5 · [step]"), then
            "Welcome back, [first name]" as the page heading; it replaces the large step title. */}
        {greeting === 'heading' ? (
          <>
            <div data-testid="journey-step-line" className="hidden sm:block" style={{ fontSize: 13, color: '#000' }}>{JOURNEY_COPY.stepLine(j.step)}</div>
            <div data-testid="journey-step-line-phone" className="sm:hidden" style={{ fontSize: 13, color: '#000' }}>{JOURNEY_COPY.stepLinePhone(j.step, j.name)}</div>
            <h1 data-testid="journey-welcome" data-greeting="heading" style={{ fontSize: 26, fontWeight: 800, color: '#000', margin: '2px 0 0', lineHeight: 1.25 }}>
              {JOURNEY_COPY.welcome(welcomeName || '')}
            </h1>
          </>
        ) : welcomeName !== undefined && greeting === 'b' ? (
          <div data-testid="journey-step-line" style={{ fontSize: 13, color: '#000' }}>
            <span data-testid="journey-welcome" data-greeting="b">{JOURNEY_COPY.welcome(welcomeName)}</span>{' · '}{JOURNEY_COPY.stepLine(j.step)}
          </div>
        ) : welcomeName !== undefined && greeting === 'd' ? (
          <div data-testid="journey-step-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
            <div data-testid="journey-step-line" style={{ fontSize: 13, color: '#000' }}>{JOURNEY_COPY.stepLine(j.step)}</div>
            <div data-testid="journey-welcome" data-greeting="d" style={{ fontSize: 13, color: '#000' }}>{JOURNEY_COPY.welcome(welcomeName)}</div>
          </div>
        ) : (
          <div data-testid="journey-step-line" style={{ fontSize: 13, color: '#000' }}>{JOURNEY_COPY.stepLine(j.step)}</div>
        )}
        {greeting !== 'heading' && <div data-testid="journey-step-name" style={{ fontSize: 18, fontWeight: 600, color: '#000', marginTop: 2 }}>{j.name}</div>}
        <div style={{ marginTop: 12 }}>
          <GuidedProgress step={j.step} total={j.total} valueText={`${JOURNEY_COPY.stepLine(j.step)}, ${j.name}`} />
        </div>
        {/* 🔑 The five step names under the bar, the current one bold (Hannah's review 2026-11-03 item 4) — sm and up only;
            a phone keeps the bar and "Step X of 5". One column per segment, so each name sits under its own segment. */}
        <div data-testid="journey-step-names" className="hidden sm:grid" aria-hidden="true"
          style={{ gridTemplateColumns: `repeat(${j.total}, minmax(0, 1fr))`, gap: 4, marginTop: 8 }}>
          {journeyStepNameRow(j.step).map((s) => (
            <div key={s.step} data-testid="journey-step-names-item" data-current={s.current ? 'true' : 'false'}
              style={{ fontSize: 12.5, color: '#000', fontWeight: s.current ? 700 : 400, lineHeight: 1.3 }}>{s.name}</div>
          ))}
        </div>
        {welcomeName !== undefined && greeting === 'a' && (
          <GuidedWelcomeCard testId="journey-welcome">{JOURNEY_COPY.welcome(welcomeName)}.</GuidedWelcomeCard>
        )}
      </div>
    </div>
  );
}
